import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_DocumentsDemanded extends _Event {
    constructor(payload: EventSchema<LoanRequest_DocumentsDemanded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            attribution: z.nativeEnum(APPLICANT_ATTRIBUTIONS),
            documents: z.array(z.string().min(1)).min(1),
            userId: schemaId,
        });
    }

    static example(): EventSchema<LoanRequest_DocumentsDemanded> {
        return {
            attribution: APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_1,
            documents: ['Document 1', 'Document 2'],
            userId: '1b9d6bcd-bbfd-4b2d-8b5d-ab8dfbbd4b1e',
        };
    }
}
